<main id="main">
    <kokos-header [page]="PagesEnum.SendMail" [title]="'sendmail.prepare.title' | i18next"></kokos-header>

    <div class="container-fluid ba-mailbox">

        <p class="ba-required-hint">{{ 'sendmail.fill-marked-fields' | i18next }}</p>


        @if (anliegenList.length > 0) {
            <pf-section name="art-leistung" [title]="'sendmail.prepare.kiwi.service-type' | i18next"
                        [subtitle]="'sendmail.prepare.kiwi.service-type-info' | i18next">
                <pf-radio-enhanced
                        name="art-leistung"
                        [value]="anliegen?.id"
                        (valueChange)="onAnliegenChanged($event)"
                        [legend]="'sendmail.prepare.kiwi.service-type-label' | i18next"
                        [options]="anliegenOptions">
                </pf-radio-enhanced>
            </pf-section>
        }

        @if (!!anliegen) {
            <pf-section name="anliegen" [title]="'sendmail.prepare.kiwi.concern' | i18next"
                        [subtitle]="'sendmail.prepare.kiwi.concern-info' | i18next">
                <pf-radio-enhanced
                        name="anliegen"
                        [value]="wantsUploadDokumente"
                        (valueChange)="onDokumenteOptionChanged($event)"
                        [legend]="'sendmail.prepare.kiwi.concern-label' | i18next"
                        [options]="dokumenteOptions">
                </pf-radio-enhanced>
            </pf-section>
        }

        @if (wantsUploadDokumente === false) {

            <pf-section name="dokumente-hinweise" [title]="'sendmail.prepare.kiwi.docs-info-title' | i18next">
                <pf-hinweisbox [boxType]="HinweisboxTypeEnum.INFO" [boxTitle]="'sendmail.prepare.kiwi.hint' | i18next"
                               boxId="dokumente">
                    <p> {{ 'sendmail.prepare.kiwi.docs-info-possible' | i18next }}</p>
                    <p>
                        <pf-link-out
                                name="dokumente-hinweise"
                                [link]="(anliegen.name === KinderLeistung.KINDERGELD)?linkKindergeld:linkKinderzuschlag"
                                [linkText]="'sendmail.prepare.kiwi.docs-submit-link-text' | i18next"></pf-link-out>
                    </p>
                </pf-hinweisbox>
            </pf-section>

        } @else if (wantsUploadDokumente) {
            <pf-section name="dokumente-hinweise" [title]="'sendmail.prepare.kiwi.docs-info-title' | i18next">
                <p> {{ 'sendmail.prepare.kiwi.docs-info-impossible' | i18next }}</p>
                <p>
                    <pf-link-out
                            name="dokumente-hinweise"
                            [link]="(anliegen.name === KinderLeistung.KINDERGELD)?linkKindergeld:linkKinderzuschlag"
                            [linkText]="'sendmail.prepare.kiwi.docs-submit-link-text' | i18next"></pf-link-out>
                </p>
            </pf-section>

        }

        <pf-footer [forwardButton]="isReadyToProceed()?forwardButtonConfig:null" [backButton]="backButtonConfig"
                   (forwardButtonClicked)="handleForwardClicked()"
                   (backButtonClicked)="handleBackClicked()"></pf-footer>

    </div>

</main>